// extracted by mini-css-extract-plugin
export default {"addCountry":"addCountry_addCountry__qfQY6","addCountry__head":"addCountry_addCountry__head__pb6Jk"};